import React from 'react';

import {
	useClassNames,
} from '@common';

import './Textbox.scss';

interface TextboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
	onValueChange?: (newValue: string) => void
	type?: string,
}

function Textbox(props: TextboxProps): JSX.Element {
	const {
		onValueChange,
		className,
		type,
		...inputProps
	} = props;

	const classes = useClassNames(
		'textbox',
		className,
	);

	const onInputChange = (ev) => {
		if (onValueChange) {
			onValueChange(ev.target.value);
		}
	}

	return (
		<input
			type={type || 'text'}
			className={classes}
			onChange={onInputChange}
			{...inputProps}
		/>
	);
}

export {Textbox};